import { render, staticRenderFns } from "./ProjectileMotionProViz.vue?vue&type=template&id=8fb639ce&scoped=true"
import script from "./ProjectileMotionProViz.vue?vue&type=script&lang=js"
export * from "./ProjectileMotionProViz.vue?vue&type=script&lang=js"
import style0 from "./ProjectileMotionProViz.vue?vue&type=style&index=0&id=8fb639ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fb639ce",
  null
  
)

export default component.exports